import React, { useState } from "react";
import axios from "axios";
import { ProgressBar } from "react-loader-spinner";
import "./Weather.css";
import Picture from "./img/3353166.jpg";
import ForecastPic from "./img/20945178.jpg";
import WeatherInfo from "./WeatherInfo";
import WeatherForecast from "./WeatherForecast";

export default function CurrentWeather() {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState("Kryvyi Rih");

  function showInfo(response) {
    setWeatherData({
      ready: true,
      temp: response.data.main.temp,
      wind: response.data.wind.speed,
      humidity: response.data.main.humidity,
      pressure: response.data.main.pressure,
      maxTemp: response.data.main.temp_max,
      minTemp: response.data.main.temp_min,
      sunrise: new Date(response.data.sys.sunrise * 1000),
      sunset: new Date(response.data.sys.sunset * 1000),
      description: response.data.weather[0].description,
      date: new Date(response.data.dt * 1000),
      iconUrl: `https://openweathermap.org/img/wn/${response.data.weather[0].icon}@2x.png`,
      city: response.data.name,
      lat: response.data.coord.lat,
      lon: response.data.coord.lon,
    });
  }

  function search() {
    const key = "cc51a9af04c66250e3d2034bcced18b7";
    const units = "metric";
    const url = `https://api.openweathermap.org/data/2.5/weather?q=${city}&units=${units}&appid=${key}`;

    axios.get(url).then(showInfo);
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function handleCityChange(event) {
    setCity(event.target.value);
  }

  if (weatherData.ready) {
    return (
      <div className="card Weather">
        <div className="row g-0">
          <div className="col-2 m-auto">
            <img src={ForecastPic} className="img-fluid" alt="Forecast" />
          </div>
          <div className="col-8 m-auto">
            <div className="row text-center mt-2 select">
              <h2 className="card-title p-0">Weather vidget</h2>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-9">
                  <input
                    type="search"
                    placeholder="Enter a city"
                    className="form-control"
                    autoFocus="on"
                    onChange={handleCityChange}
                  />
                </div>
                <div className="col-3">
                  <input
                    type="submit"
                    value="Search"
                    className="btn btn-primary w-100"
                  />
                </div>
              </div>
            </form>
          </div>
          <div className="col-2 m-auto">
            <img src={Picture} className="img-fluid" alt="Cloud" />
          </div>
        </div>
        <WeatherInfo data={weatherData} />
        <WeatherForecast data={weatherData} />
      </div>
    );
  } else {
    search();
    return (
      <div align="center">
        <ProgressBar
          height="80"
          width="80"
          ariaLabel="progress-bar-loading"
          wrapperStyle={{}}
          wrapperClass="progress-bar-wrapper"
          borderColor="white"
          barColor="#51E5FF"
        />
      </div>
    );
  }
}
